import { Card, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Button from 'components/base/Button';
// import { notifications as notificationData } from 'data/notifications';
// import NotificationItem from 'components/common/NotificationItem';
import classNames from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const NotificationDropdownMenu = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  // const [notifications] = useState(notificationData.slice(0, 6));

  const notifications = []
  return (
    <Dropdown.Menu
      align="end"
      className={classNames(
        className,
        'navbar-dropdown-caret py-0 notification-dropdown-menu shadow border'
      )}
    >
      <Card className="position-relative border-0">
        <Card.Header className="p-2">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="text-body-emphasis mb-0">{t('notifications')}</h5>
            <Button variant="link" className="p-0 fs-9 fw-normal">
              {t('mark_all_as_read')}
            </Button>
          </div>
        </Card.Header>
        <Card.Body className="p-0" style={{ height: '27rem' }}>
          <div>
            {/*{notifications.map((notification, index) => (*/}
            {/*  <NotificationItem*/}
            {/*    notification={notification}*/}
            {/*    type="dropdownItem"*/}
            {/*    className={classNames({*/}
            {/*      'border-bottom border-translucent':*/}
            {/*        index !== notifications.length - 1*/}
            {/*    })}*/}
            {/*    key={notification.id}*/}
            {/*  />*/}
            {/*))}*/}
          </div>
        </Card.Body>
        <Card.Footer className="p-0 border-top">
          <div className="my-2 text-center fw-bold fs-10 text-body-tertiary text-opactity-85">
            <Link to="/pages/notifications" className="fw-bolder">
              {t('notification_history')}
            </Link>
          </div>
        </Card.Footer>
      </Card>
    </Dropdown.Menu>
  );
};

export default NotificationDropdownMenu;
